import React from "react";

import { useDispatch } from "react-redux";
import { setCatalog } from "../../redux/actions/catalog";

import Img1 from "../../assets/img/catalog-category/01.png";
import Img2 from "../../assets/img/catalog-category/02.png";
import Img3 from "../../assets/img/catalog-category/03.png";
import Img4 from "../../assets/img/catalog-category/04.png";
import Img5 from "../../assets/img/catalog-category/05.png";
import Img6 from "../../assets/img/catalog-category/06.png";
import Img7 from "../../assets/img/catalog-category/07.png";
import imgAlpha from "../../assets/img/catalog-category/alpha.png";
import imgSigma from "../../assets/img/catalog-category/sigma.png";

function Catalog({ activePage, setActivePage }) {

	const dispatch = useDispatch();

	const openCatalog = index => {
		dispatch(setCatalog(index));
		setActivePage("home");
	}

	return (
		<>
			<div className="taste-wrapper">
				<section className="catalog-category">
					<div className="catalog-category__content">
						{/* <div className="catalog-category__top">
						<div className="catalog-category__top-item catalog-category__item _1"  style={{background: 'linear-gradient(to bottom right, #eee, #221e38)'}}
							    onClick = {() => openCatalog(0)}>
								<div className="catalog-category__item-left">
									<h2 className="catalog-category__title" style={{letterSpacing: '.05rem', fontSize: '2.5rem', fontWeight: '700', marginTop: '1rem', color: '#333', lineHeight: '3rem', marginBottom: '0'}}>
										Alpha 
										<span style={{color: 'white', marginLeft: '.5rem', borderRadius: '5px', backgroundColor: '#1f1e6a', paddingLeft: '.5rem', paddingRight: '.5rem'}}>
											NEW
										</span>
									</h2>
									<h3 className="catalog-category__subtitle" style={{color: '#888', letterSpacing: '.05rem', fontWeight: '300', fontSize: '1.5rem'}}>
										/Extra Salt
									</h3>
								</div>
								<div className="">
									<img
										src={imgAlpha}
										alt="Премiкс 18 мл"
										className="catalog-category__item-img"
										style={{marginRight: '2rem', height: '400px', }}
									/>

								</div>

							</div>
						</div>	 */}

						<div className="catalog-category__top">
							<div className="catalog-category__top-item catalog-category__item _1" style={{ background: 'linear-gradient(to bottom right, #eee, #221e38)', width: '100%', height: '380px' }}
								onClick={() => openCatalog(1)}>
								<div className="catalog-category__item-left">
									<h2 className="catalog-category__title" style={{ letterSpacing: '.05rem', fontSize: '1.75rem', fontWeight: '700', color: '#333', lineHeight: '3rem', marginBottom: '0' }}>
										Alpha
										{/*<span style={{ color: 'white', marginLeft: '.5rem', borderRadius: '5px', backgroundColor: '#1f1e6a', paddingLeft: '.5rem', paddingRight: '.5rem' }}>
											NEW
										</span>*/}
									</h2>
									<h3 className="catalog-category__subtitle" style={{ color: '#888', letterSpacing: '.05rem', fontWeight: '300', fontSize: '1rem' }}>
										/for PODS
									</h3>
								</div>
								<div className="" style={{ position: 'relative', right: '220px', top: '75px' }}>
									<img
										src={imgAlpha}
										className="catalog-category__item-img"
										style={{ height: '250px', position: 'absolute' }}
									/>

								</div>

							</div>

							<div className="catalog-category__top-item catalog-category__item _1" style={{ background: 'linear-gradient(to bottom right, #eee, #460000ff)', width: '100%', height: '380px' }}
								onClick={() => openCatalog(0)}>
								<div className="catalog-category__item-left">
									<h2 className="catalog-category__title" style={{ letterSpacing: '.05rem', fontSize: '1.75rem', fontWeight: '700', color: '#333', lineHeight: '3rem', marginBottom: '0' }}>
										Sigma
										<span style={{ color: 'white', marginLeft: '.5rem', borderRadius: '5px', backgroundColor: '#910000ff', paddingLeft: '.5rem', paddingRight: '.5rem' }}>
											NEW
										</span>
									</h2>
									<h3 className="catalog-category__subtitle" style={{ color: '#888', letterSpacing: '.05rem', fontWeight: '300', fontSize: '1rem' }}>
										/Extra Salt
									</h3>
								</div>


								<div className="" style={{ position: 'relative', right: '220px', top: '75px' }}>
									<img
										src={imgSigma}
										alt="Премiкс 18 мл"
										className="catalog-category__item-img"
										style={{ height: '250px', position: 'absolute' }}
									/>

								</div>

							</div>


							{/* 
								Закомменченную плашку ниже не убирать ни в коем случае
							*/}
							
							{/*<div className="catalog-category__top-item catalog-category__item _2"
								style={{ width: '100%' }}
								onClick={() => openCatalog(2)}
							>
								<div className="catalog-category__item-left">
									<h2 className="catalog-category__title">Премiкс 12 мл</h2>
									<h3 className="catalog-category__subtitle">Salt</h3>
								</div>
								<div className="" style={{ position: 'relative', right: '220px', top: '75px' }}>
									<img
										src={Img2}
										alt="Премiкс 12 мл"
										className="catalog-category__item-img"
										style={{ height: '250px', position: 'absolute' }}
									/>

								</div>

							</div>*/}

							<div className="catalog-category__top-item catalog-category__item _1"
								style={{ width: '100%' }}
								onClick={() => openCatalog(3)}
							>
								<div className="catalog-category__item-left">
									<h2 className="catalog-category__title">Премiкс 18 мл</h2>
									<h3 className="catalog-category__subtitle">Organic</h3>
								</div>
								<div className="" style={{ position: 'relative', right: '220px', top: '75px' }}>
									<img
										src={Img1}
										alt="Премiкс 18 мл"
										className="catalog-category__item-img"
										style={{ height: '250px', position: 'absolute' }}
									/>
								</div>

							</div>
						</div>

						<div className="catalog-category__top">
							<div className="catalog-category__top-item catalog-category__item _5"
								onClick={() => openCatalog(2)}>
								<div className="catalog-category__item-left">
									<h2 className="catalog-category__title">Набiр 15 мл</h2>
									<h3 className="catalog-category__subtitle">Salt</h3>
								</div>
								<img
									src={Img6}
									alt="Премiкс 18 мл"
									className="catalog-category__item-img"
									style={{ width: '320px', height: '320px' }}
								/>
							</div>
							<div className="catalog-category__top-item catalog-category__item _4"
								onClick={() => openCatalog(4)}>
								<div className="catalog-category__item-left">
									<h2 className="catalog-category__title">Набiр 60 мл</h2>
									<h3 className="catalog-category__subtitle">Salt</h3>
								</div>
								<img
									src={Img7}
									alt="Премiкс 12 мл"
									className="catalog-category__item-img"
									style={{ width: '320px', height: '320px' }}
								/>
							</div>
						</div>

						<div className="catalog-category__bottom">
							<div className="catalog-category__bottom-item catalog-category__item _3"
								onClick={() => openCatalog(5)}>
								<div className="catalog-category__bottom-item catalog-category__item">
									<div className="catalog-category__item-left">
										<h2 className="catalog-category__title">Гліцерин</h2>
									</div>
									<img
										src={Img3}
										alt="Гліцерин"
										className="catalog-category__item-img"
									/>
								</div>
							</div>
							<div className="catalog-category__bottom-item catalog-category__item _4"
								onClick={() => openCatalog(6)}>
								<div className="catalog-category__item-left">
									<h2 className="catalog-category__title">Нікотин</h2>
								</div>
								<img
									src={Img4}
									alt="Нікотин"
									className="catalog-category__item-img"
								/>
							</div>
							<div className="catalog-category__bottom-item catalog-category__item _5"
								onClick={() => openCatalog(7)}>
								<div className="catalog-category__item-left">
									<h2 className="catalog-category__title">Мерч та інше</h2>
								</div>
								<img
									src={Img5}
									alt="Мерч та інше"
									className="catalog-category__item-img"
								/>
							</div>
						</div>
					</div>

					<div href="#" className="catalog-category__content _mob">
						<div className="catalog-category__top-item catalog-category__item _1" style={{ background: 'linear-gradient(to bottom right, #eee, #221e38)' }}
							onClick={() => openCatalog(1)}>
							<div className="catalog-category__item-left">
								<h2 className="catalog-category__title" style={{ letterSpacing: '.05rem', fontSize: '1.25rem', fontWeight: '700', color: '#333', marginBottom: '0', marginTop: '.25rem' }}>
									Alpha
									{/*<span style={{ color: 'white', marginLeft: '.25rem', borderRadius: '5px', backgroundColor: '#1f1e6a', paddingLeft: '.25rem', paddingRight: '.25rem' }}>
										NEW
									</span>*/}
								</h2>
								<h3 className="catalog-category__subtitle" style={{ color: '#888', letterSpacing: '.05rem', fontWeight: '300', fontSize: '1rem' }}>
									/for PODS
								</h3>
							</div>
							<div className="" style={{ }}>
								<img
									src={imgAlpha}
									alt="Премiкс 18 мл"
									className="catalog-category__item-img"
									style={{width: '100%'}}
								/>
							</div>
						</div>

						<div className="catalog-category__top-item catalog-category__item _1" style={{ background: 'linear-gradient(to bottom right, #eee, #460000ff)' }}
							onClick={() => openCatalog(0)}>
							<div className="catalog-category__item-left">
								<h2 className="catalog-category__title" style={{ letterSpacing: '.05rem', fontSize: '1.25rem', fontWeight: '700', color: '#333', marginBottom: '0', marginTop: '.25rem' }}>
									Sigma
									<span style={{ color: 'white', marginLeft: '.25rem', borderRadius: '5px', backgroundColor: '#910000ff', paddingLeft: '.25rem', paddingRight: '.25rem' }}>
										NEW
									</span>
								</h2>
								<h3 className="catalog-category__subtitle" style={{ color: '#888', letterSpacing: '.05rem', fontWeight: '300', fontSize: '1rem' }}>
									/Extra Salt
								</h3>
							</div>
							<div className="" style={{ }}>
								<img
									src={imgSigma}
									alt="Премiкс 18 мл"
									className="catalog-category__item-img"
									style={{width: '100%'}}
								/>
							</div>
						</div>


						{/*
							не убирать 
						*/}
						
						{/*<a
							href="#"
							className="catalog-category__top-item catalog-category__item _2"
							onClick={() => openCatalog(2)}
						>
							<div className="catalog-category__item-left">
								<h2 className="catalog-category__title">Премiкс 12 мл</h2>
								<h3 className="catalog-category__subtitle">Salt</h3>
							</div>
							<img
								src={Img2}
								alt="Премiкс 12 мл"
								className="catalog-category__item-img"
							/>
						</a>*/}

						<a className="catalog-category__top-item catalog-category__item _1"
							onClick={() => openCatalog(3)}>
							<div className="catalog-category__item-left">
								<h2 className="catalog-category__title">Премiкс 18 мл</h2>
								<h3 className="catalog-category__subtitle">Organic</h3>
							</div>
							<img
								src={Img1}
								alt="Премiкс 18 мл"
								className="catalog-category__item-img"
							/>
						</a>

						<a className="catalog-category__top-item catalog-category__item _4"
							onClick={() => openCatalog(2)}>
							<div className="catalog-category__item-left">
								<h2 className="catalog-category__title">Набiр 15 мл</h2>
								<h3 className="catalog-category__subtitle">Salt</h3>
							</div>
							<img
								src={Img6}
								alt="Премiкс 6 мл"
								className="catalog-category__item-img"
							// style={{width: '320px', height: '320px'}}
							/>
						</a>
						<a className="catalog-category__top-item catalog-category__item _5"
							onClick={() => openCatalog(4)}>
							<div className="catalog-category__item-left">
								<h2 className="catalog-category__title">Набiр 60 мл</h2>
								<h3 className="catalog-category__subtitle">Salt</h3>
							</div>
							<img
								src={Img7}
								alt="Премiкс 24 мл"
								className="catalog-category__item-img"
							// style={{width: '320px', height: '320px'}}
							/>
						</a>

						<a
							href="#"
							className="catalog-category__bottom-item catalog-category__item _3"
							onClick={() => openCatalog(5)}
						>
							<div className="catalog-category__item-left">
								<h2 className="catalog-category__title">Гліцерин</h2>
							</div>
							<img
								src={Img3}
								alt="Гліцерин"
								className="catalog-category__item-img"
							/>
						</a>
						<a
							href="#"
							className="catalog-category__bottom-item catalog-category__item _4"
							onClick={() => openCatalog(6)}
						>
							<div className="catalog-category__item-left">
								<h2 className="catalog-category__title">Нікотин</h2>
							</div>
							<img
								src={Img4}
								alt="Нікотин"
								className="catalog-category__item-img"
							/>
						</a>
						<a
							href="#"
							className="catalog-category__bottom-item catalog-category__item _5"
							onClick={() => openCatalog(7)}
						>
							<div className="catalog-category__item-left">
								<h2 className="catalog-category__title">Мерч та інше</h2>
							</div>
							<img
								src={Img5}
								alt="Мерч та інше"
								className="catalog-category__item-img"
							/>
						</a>
					</div>
				</section>
			</div>
		</>
	);
}

export default Catalog;
